module.exports = __webpack_public_path__ + "img/客户icon_1.44e4ca1f.png";